import script from "./handoff.vue?vue&type=script&setup=true&lang=js"
export * from "./handoff.vue?vue&type=script&setup=true&lang=js"

import "./handoff.vue?vue&type=style&index=0&id=a3f00f38&lang=less&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WWW\\quality-control-crm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f00f38"]])

export default __exports__